import Material from "../Materials"

export default function Structure(params) {
    const sm = <Material material={params.material} type={params.type} texture={params.texture}/> 
    return (
        <group item="structure">
          <mesh  
          castShadow
          receiveShadow
          position={[params.size/2, /*try*/+params.dim[2]/2, -params.dim[0]/2+params.size/2]} item={`structure-1`}
          >{sm}
            <boxGeometry args={[params.size,params.dim[2],params.size]} />
          </mesh>
          <mesh  
          castShadow
          receiveShadow
          position={[params.size/2, /*try*/+params.dim[2]/2, params.dim[0]/2-params.size/2]} item={`structure-2`}>{sm}
            <boxGeometry args={[params.size,params.dim[2],params.size]} />
          </mesh>
          <mesh  
          castShadow
          receiveShadow
          position={[params.dim[1]-params.size/2, /*try*/+params.dim[2]/2, -params.dim[0]/2+params.size/2]} item={`structure-3`}>{sm}
            <boxGeometry args={[params.size,params.dim[2],params.size]} />
          </mesh>
          <mesh  
            castShadow
            receiveShadow
            position={[params.dim[1]-params.size/2, /*try*/+params.dim[2]/2, params.dim[0]/2-params.size/2]} item={`structure-4`}
          >
            {sm}
            <boxGeometry args={[params.size,params.dim[2],params.size]} />
          </mesh>
        </group>
    )
}
  